import type { RouterOutputs } from '@klear/ui/lib/trpc'
import type { OrderEventListFiltersShared } from '@klear/order-event/order-event-list-filters-shared.wire'
import type { OrderEventListFilters } from '@klear/order-event/order-event-list-filters.wire'
import { trpc } from '@klear/ui/lib/trpc'
import {
  isSharedOrderEventListQueryEnabled,
  type SharedOrderEventListQueryOptions
} from '@klear/ui/hooks/order-event-list-query-options'
import isNaN from 'lodash/isNaN'
import omit from 'lodash/omit'

export type InvoiceListItem = RouterOutputs['invoice']['list']['invoices'][number]

const EMPTY_INVOICES: InvoiceListItem[] = []

export function invoiceListFiltersFromOrderEventFilters(filters?: OrderEventListFilters): OrderEventListFiltersShared {
  if (!filters) return {}
  const { orderEventId, trader, effectiveStartDate, effectiveEndDate, endDateFrom, endDateTo } = filters
  const rest = omit(filters, [
    'orderEventId',
    'trader',
    'effectiveStartDate',
    'effectiveEndDate',
    'endDateFrom',
    'endDateTo',
    'type',
    'stripeStatus',
    'includeLog',
    'fundingOrganizationId',
    'beneficiaryId',
    'traderOrganizationId',
    'excludeTrader'
  ])

  const traderIdFromTrader = trader?.[0] != null ? parseInt(trader[0], 10) : undefined

  return {
    order: rest.order,
    traderId:
      rest.traderId ?? (traderIdFromTrader != null && !isNaN(traderIdFromTrader) ? traderIdFromTrader : undefined),
    status: rest.status,
    search: rest.search,
    parentEventId: rest.parentEventId,
    orderEventId,
    limit: rest.limit,
    offset: rest.page != null && rest.limit != null ? (rest.page - 1) * rest.limit : undefined,
    effectiveStartDate,
    effectiveEndDate,
    endDateFrom,
    endDateTo
  }
}

export function useInvoices(filters?: OrderEventListFiltersShared, options?: SharedOrderEventListQueryOptions) {
  const isEnabled = isSharedOrderEventListQueryEnabled(filters, options)

  const { data, error, isLoading, refetch } = trpc.invoice.list.useQuery(filters ?? {}, { enabled: isEnabled })

  const invoices = data?.invoices ?? EMPTY_INVOICES

  return { invoices, total: data?.total ?? 0, error, isLoading, refetch }
}
